import { type Agent } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

export const isAutodevTemplateAgent = (agent: Agent): boolean => {
	return !!agent.external_config_reference?.startsWith('autodev_template_');
};
